export enum CommunityVisitorActionType {
    LINK = 1
}